/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

import uuidv4 from 'uuid/v4';

import dbg from "debug";
const debug = dbg('lnbig:cmd-glue')

class CommandGlue {
    constructor () {
        this.uuidGenerator = uuidv4
        this.uuids = {}
    }

    // Создаёт Promise с выполнением следующей команды. Если nextCommand придёт из сокета, и uuid у неё будет такой же как у этой, то Promise будет resolved
    add (code, nextCommand, payload = null, rejectTimeout = 10000) {
        debug('add(), nextCommand: %s', nextCommand)
        let item = { command: nextCommand, payload }
        this.uuids[item.uuid = this.uuidGenerator()] = item
        return item.promise = new Promise( (resolve, reject) => {
            item.resolve = resolve
            item.reject = reject
            item.rejectTimeout = setTimeout(
                (error) => {
                    delete this.uuids[item.uuid]
                    reject(error)
                },
                rejectTimeout,
                new Error(`Timeout for ${nextCommand} command elapsed (${rejectTimeout}ms)`)
            )
            code(item.uuid)
        })
    }

    // Находит promise для этого ответа и resolve его, или reject
    find (cmdName, data, cbValue) {
        debug('find(): %s, data: %o', cmdName, data)
        let obj
        if (data.uuid) {
            if (obj = this.uuids[data.uuid]) {
                // В данных есть uuid и мы нашли связанный объект
                clearTimeout(obj.rejectTimeout)
                obj.rejectTimeout = null
                if (data['error']) {
                    debug('find(): rejected')
                    obj.reject(new Error(data['error']))
                }
                else {
                    debug('find(): resolved')
                    obj.resolve(cbValue(data, obj.payload))
                }
                delete this.uuids[data.uuid]
            }
            else {
                throw new Error(`The command ${cmdName} has incorrect uuid ${data.uuid}`)
            }
        }
        else {
            throw new Error(`The command ${cmdName} expected a uuid but it misses`)
        }
    }
}

export default new CommandGlue()
